export { StaticEmbedSetupPane } from "./StaticEmbedSetupPane";
